import { Module, MutationTree, ActionTree } from 'vuex'

interface State {
  prompt: any,
}

const state: State = {
  prompt: null
}

const getters = {
}

const actions: ActionTree<State, any> = {
  prompt: ({ state, commit }) => {
    const prompt = state.prompt;

    console.log('Prompting for install');

    prompt.prompt();
    prompt.userChoice.then((choiceResult: any) => {
      console.log('User made A2HS choice')

      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt')
      } else {
        console.log('User dismissed the A2HS prompt')
      }

      commit('install/setPrompt', null)
    })
  },
}

const mutations: MutationTree<State> = {
  setPrompt(state, prompt) {
    state.prompt = prompt
  }
}

const mod: Module<State, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default mod
